module.exports = __webpack_public_path__ + "static/img/1.b4eb644.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/sp/1.png
// module id = 8jE3
// module chunks = 0